module.exports = __webpack_public_path__ + "static/media/classThree.3d605f68.jpg";